import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import Tokens from '../models/tokens';


@Injectable({
  providedIn: 'root'
})
export class AgencyGuard implements CanActivate, CanActivateChild, CanLoad {
  isAgency = false;

  constructor(private router: Router, private store: Store<any>) {
    this.store.select(state => state.tokens)
      .subscribe((tokens: Tokens) => {
        this.isAgency = !!tokens.agencyToken;
      });
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
